const CATEGORY_COLORS = {
  "JATOBÁ": "#895A2B",
  "MARFIM": "#E8CCA5",
  "IMBUIA": "#D29E17",
  "JACARANDÁ": "#440D0D",
  "JACARANDÁ PLUS": "#99111E",
};

const DEFAULT_COLOR = "#72B502";

const CATEGORIES_ORDER = [
  "JATOBÁ",
  "MARFIM",
  "IMBUIA",
  "JACARANDÁ",
  "JACARANDÁ PLUS",
];

// Mínimos de compra por categoria (valores fixos da RD 91535, em reais).
const CATEGORY_MINIMUMS = {
  "JATOBÁ": 1,
  "MARFIM": 25500,
  "IMBUIA": 51000,
  "JACARANDÁ": 102000,
  "JACARANDÁ PLUS": 204000,
};

function normalizeName(name) {
  if (!name) return "";
  return name
    .trim()
    .toUpperCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "");
}

function findCategory(categoryName) {
  var normalized = normalizeName(categoryName);
  return CATEGORIES_ORDER.find(
    function (cat) { return normalizeName(cat) === normalized; }
  );
}

function getCategoryColor(categoryName) {
  var match = findCategory(categoryName);
  return match ? CATEGORY_COLORS[match] : DEFAULT_COLOR;
}

function getCategoryIndex(categoryName) {
  var match = findCategory(categoryName);
  return match ? CATEGORIES_ORDER.indexOf(match) : -1;
}

function getTextColor(categoryName) {
  var match = findCategory(categoryName);
  if (match === "MARFIM" || match === "IMBUIA") return "#000";
  return "#fff";
}

// Retorna o alvo de compras da categoria atual, quanto falta para alcançá-lo e
// a fração já preenchida (0..1). "Faltam R$" nunca é negativo (zera ao atingir
// o alvo) e a fração satura em 1.
//
// A última categoria (JACARANDÁ PLUS) não tem próxima: o alvo passa a ser o
// mínimo dela mesma, porque o participante precisa atingi-lo para MANTER a
// categoria (sinalizado por manterCategoria). Nas demais, o alvo é o mínimo da
// próxima categoria, que é o que ele precisa para evoluir.
function getNextCategoryInfo(categoryName, valorComprado) {
  var match = findCategory(categoryName);
  var index = match ? CATEGORIES_ORDER.indexOf(match) : -1;

  // Sem categoria pontuável: modo "sem progressão" (grade esmaecida, sem indicador).
  if (index < 0) {
    return {
      proximaCategoria: null,
      faltamReais: 0,
      fracaoPreenchida: 1,
      manterCategoria: false,
    };
  }

  var manterCategoria = index === CATEGORIES_ORDER.length - 1;
  var proxima = manterCategoria ? null : CATEGORIES_ORDER[index + 1];
  var alvo = CATEGORY_MINIMUMS[manterCategoria ? match : proxima] || 0;
  var comprado = valorComprado || 0;

  return {
    proximaCategoria: proxima,
    faltamReais: Math.max(0, alvo - comprado),
    fracaoPreenchida: alvo > 0 ? Math.min(comprado / alvo, 1) : 1,
    manterCategoria: manterCategoria,
  };
}

export {
  CATEGORY_COLORS,
  CATEGORIES_ORDER,
  CATEGORY_MINIMUMS,
  DEFAULT_COLOR,
  getCategoryColor,
  getCategoryIndex,
  getTextColor,
  getNextCategoryInfo,
};
